import { QuickQuestionOption } from '@gelato-api-ui/core/quick-questions/constants/quck-question-option';
import { IndustryOptionIdEnum } from '@gelato-api-ui/core/quick-questions/types/industry-option-id.enum';

export const IndustryOptions: QuickQuestionOption[] = [
  { id: IndustryOptionIdEnum.Clothing, name: 'txt_clothing', subtitle: 'txt_question_subtitle_clothing' },
  { id: IndustryOptionIdEnum.WallArt, name: 'txt_wall_art', subtitle: 'txt_question_subtitle_wall_art' },
  { id: IndustryOptionIdEnum.PaperPrints, name: 'txt_paper_prints', subtitle: 'txt_question_subtitle_paper_prints' },
  { id: IndustryOptionIdEnum.Drinkware, name: 'txt_drinkware', subtitle: 'txt_question_subtitle_drinkware' },
  { id: IndustryOptionIdEnum.OtherMerch, name: 'txt_other_merch', subtitle: 'txt_question_subtitle_other_merch' },
];
